import styled from '@emotion/styled';
import { colors } from '../theme/tokens';

const StyledInput = styled.input`
  padding: 0.75rem 1rem;
  border: 1px solid ${colors.neutral.lightCharcoal};
  border-radius: 4px;
  font-size: 1rem;
  width: 100%;
  transition: border-color 0.2s ease;
  background-color: ${colors.neutral.white};
  color: ${colors.neutral.darkCharcoal};

  &:focus {
    outline: none;
    border-color: ${colors.brand.laurel};
  }

  &::placeholder {
    color: ${colors.neutral.lightCharcoal};
  }
`;

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  // Add any additional props here
}

export function Input(props: InputProps) {
  return <StyledInput {...props} />;
} 